export const roomViewTypesConstants = {
    ROOM_VIEW_TYPE_PENDING  : 'ROOM_VIEW_TYPE_PENDING',
    ROOM_VIEW_TYPE_FULFILLED: 'ROOM_VIEW_TYPE_FULFILLED',
    ROOM_VIEW_TYPE_REJECTED : 'ROOM_VIEW_TYPE_REJECTED',
}